import { useNavigate } from "react-router-dom";

import Loader from "../Loader";
import EmptyTable from "../EmptyTable";

const TeachersTable = ({ loading, data, teacherId }) => {
  const navigate = useNavigate();

  function handleNavigate(params) {
    navigate(`/users/teachers?selected=${params?.userId}`);
  }

  return (
    <div className="table_wrapper">
      <div className="min-w-[900px]">
        {/* table header */}
        <div className="grid grid-cols-7 border-b">
          <div className="col-span-2 border-r p-3">
            <h5 className="font-semibold text-sm">Name</h5>
          </div>

          <div className="border-r p-3 col-span-2">
            <h5 className="font-semibold text-sm">Email Address</h5>
          </div>

          <div className="p-3 border-r">
            <h5 className="font-semibold text-sm">Phone Number</h5>
          </div>

          <div className="p-3 border-r">
            <h5 className="font-semibold text-sm">Gender</h5>
          </div>

          <div className="p-3">
            <h5 className="font-semibold text-sm">Date Joined</h5>
          </div>
        </div>

        {loading ? <Loader loading={loading} /> : null}

        {!loading && !data?.length ? (
          <EmptyTable
            //   image={subjectBookImage}
            message={"No teacher record found"}
          />
        ) : null}

        {/* Table body */}
        {data?.map((item, i) => (
          <div
            className={`grid grid-cols-7 border-b table_row ${
              teacherId === item?.teacherId ? "active_table_row" : ""
            }`}
            key={i}
            onClick={() => handleNavigate(item)}
          >
            <div className="col-span-2 border-r p-3">
              <p className="text-independence text-sm capitalize">
                {item?.lastName} {item?.firstName}
              </p>
            </div>

            <div className="border-r p-3 col-span-2">
              <p className="text-independence text-sm">{item?.email}</p>
            </div>

            <div className="p-3 border-r">
              <p className="text-independence text-sm">{item?.phone}</p>
            </div>

            <div className="p-3 border-r">
              <p className="text-independence text-sm capitalize">
                {item?.gender?.[0]}
              </p>
            </div>

            <div className="p-3">
              <p className="text-independence text-sm">
                {new Date(item?.createdAt)?.toLocaleDateString()}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default TeachersTable;
